// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_details_XFhcDfrCmVdXDV0BOCIX tr td {
  padding: 0.75rem 1rem 0.75rem 0rem;
}

.style-module_details_XFhcDfrCmVdXDV0BOCIX tr td:first-child {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/containers/RepresentativeAggregatorCreationRequestView/components/Details/style.module.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".details tr td {\n  padding: 0.75rem 1rem 0.75rem 0rem;\n}\n\n.details tr td:first-child {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": `style-module_details_XFhcDfrCmVdXDV0BOCIX`
};
export default ___CSS_LOADER_EXPORT___;
